import React, { useState } from "react";
import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddIcon from '@mui/icons-material/Add';

/**
 * ActionButton component for DataSetup cards
 * Modern minimalist button with smooth animations
 * @param {string} iconSrc - Path to the icon image
 * @param {string} text - Button text
 * @param {function} onClick - Click handler
 * @param {object} sx - Additional sx props for customization
 */
const ActionButton = ({ iconSrc, text, onClick, sx = {} }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Stack
            spacing={0.8}
            direction="row"
            alignItems="center"
            justifyContent="center"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={onClick}
            sx={{
                cursor: "pointer",
                padding: "8px 16px",
                borderRadius: "8px",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                boxShadow: isHovered
                    ? isDark
                        ? `0 8px 24px ${theme.palette.primary.main}50, 0 4px 12px ${theme.palette.secondary.main}30`
                        : `0 8px 24px ${theme.palette.primary.main}40, 0 4px 12px ${theme.palette.secondary.main}25`
                    : isDark
                        ? `0 4px 12px ${theme.palette.primary.main}40`
                        : `0 4px 12px ${theme.palette.primary.main}30`,
                userSelect: "none",
                "&:hover": {
                    transform: "translateY(-2px)",
                    background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.secondary.light} 100%)`,
                },
                "&:active": {
                    transform: "translateY(0px)",
                },
                ...sx,
            }}
        >
            {iconSrc && (
                <AddIcon
                    sx={{
                        color: "#ffffff",
                        fontSize: "1.1rem",
                    }}
                />
            )}

            <Typography
                variant="button"
                sx={{
                    fontWeight: 600,
                    color: "#ffffff",
                    letterSpacing: 0.5,
                    fontSize: "0.8125rem",
                    transition: "all 0.3s ease",
                }}
            >
                {text}
            </Typography>
        </Stack>
    );
};

export default ActionButton;
